import { useEffect, useState } from "react";
import { auth, db } from "../services/firebase";
import { ref, get } from "firebase/database";

/**
 * ✅ Checks whether the current user has access to a given pack
 * - Fetches single record: Payments/Purchases/${uid}/${domainId}/${packId}
 * - Returns { loading, hasAccess, expired, purchaseData }
 */
export default function useCheckPackAccess(domainId, packId) {
    const [hasAccess, setHasAccess] = useState(false);
    const [expired, setExpired] = useState(false);
    const [loading, setLoading] = useState(true);
    const [purchaseData, setPurchaseData] = useState(null);

    useEffect(() => {
        const fetchAccess = async () => {
            const user = auth.currentUser;
            if (!user || !domainId || !packId) {
                setHasAccess(false);
                setExpired(false);
                setLoading(false);
                return;
            }

            try {
                const purchaseRef = ref(db, `Payments/Purchases/${user.uid}/${domainId}/${packId}`);
                const snapshot = await get(purchaseRef);

                if (!snapshot.exists()) {
                    setHasAccess(false);
                    setExpired(false);
                    setPurchaseData(null);
                } else {
                    const data = snapshot.val();
                    setPurchaseData(data);

                    const expiresAt = data.expiresAt || null;
                    const now = Date.now();
                    const isExpired = expiresAt ? now > expiresAt : false;

                    setExpired(isExpired);
                    setHasAccess(!isExpired);
                }
            } catch (err) {
                console.error("❌ Error checking pack access:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAccess();
    }, [domainId, packId]);

    return { hasAccess, expired, loading, purchaseData };
}
